import { z } from 'zod';
import { dateSchema, priceSchema } from '../../validation';

/** Status of the invoice-level cashback. */
export const invoiceCashbackStatusSchema = z.enum([
  'active',
  'applied',
  'expired',
]);
export type InvoiceCashbackStatus = z.infer<typeof invoiceCashbackStatusSchema>;

/** Schema for invoice-level cashback (embedded in the Invoice document). */
export const invoiceCashbackSchema = z.object({
  /** Cashback percentage as a decimal (e.g. 0.05 for 5%). */
  percentage: z.number().min(0).max(1),
  /** Current status of the cashback offer for this invoice. */
  status: invoiceCashbackStatusSchema,
  /** When this cashback tier expires (recalculated daily by cron). */
  expiresAt: dateSchema,
  /** When the cashback was actually credited to the payer wallet. */
  appliedAt: dateSchema.optional(),
  /** The cashback amount credited to the payer's wallet upon invoice payment approval. */
  amount: priceSchema.optional(),
});
export type InvoiceCashback = z.infer<typeof invoiceCashbackSchema>;
